// @tenorlab/vue-dashboard-pro
// file: src/bundled-widgets/widget-recent-orders/meta.ts
import type { TWidgetMetaInfo } from '@tenorlab/vue-dashboard'
import { ShoppingBag as ComponentIcon } from 'lucide-vue-next'

// Define the metadata object for the plugin
export const WidgetRecentOrders: TWidgetMetaInfo = {
  name: 'Recent Orders',
  categories: ['Widget'],
  icon: ComponentIcon,
  noDuplicatedWidgets: true,
  description: 'A list of your most recent orders.',
  externalDependencies: [],
}
